import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  Table,
  Tooltip,
  Button,
  Tag,
  Modal,
  Select,
  Input,
  Badge,
  Switch,
} from "antd";

import {
  req_page_slm_accommodation_totur,
  req_downloadfile_slm_accommodation_needConfirmTutor,
} from "../../api";

import { usrRole } from "../../utils/dataUtil";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { formateDate } from "../../utils/dateUtil";

import SurveyStudentModal from "./survey-student-modal";
import ConfirmTutorModal from "./confirm-tutor-modal";

class NeedConfirmTutor extends Component {
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "CONTRACT",

    domnloadFile: "",
    isShowStudentSurveyModal: false,
    isShowConfirmTutorModal: false,
    onlyShowNeedConfirmTag: "YES",
    onlyShowNeedTalkTag: "NO",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      onlyShowNeedConfirmTag,
      onlyShowNeedTalkTag,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true });
    const result = await req_page_slm_accommodation_totur(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      onlyShowNeedConfirmTag,
      onlyShowNeedTalkTag,
      token
    );
    this.setState({ loading: false });

    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    }else{
      this.setState({ items: [], pagination: { current: 1, pageSize: PAGE_SIZE, total: 0 } });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      onlyShowNeedConfirmTag,
      onlyShowNeedTalkTag,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_slm_accommodation_needConfirmTutor(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      onlyShowNeedConfirmTag,
      onlyShowNeedTalkTag,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "學生租屋清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "班級",
        dataIndex: "ClassroomTwName",
        width: 50,
        responsive: ["lg"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學號",
        dataIndex: "StudentId",
        width: 50,
        responsive: ["lg"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: () => {
          return this.state.deviceWidth > 600 ? "姓名" : "學生資訊";
        },
        width: 100,
        render: (item) => {
          const { deviceWidth } = this.state;
          const { TwName, Cellphone, Telephone, Email } = item;
          return (
            <>
              <div>
                <a
                  href={"mailto:" + Email}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-dark btn-sm btn-block"
                >
                  {" "}
                  <span style={{ fontSize: "1.3em" }}>{TwName}</span> ({" "}
                  <i className="far fa-envelope"></i>
                  {deviceWidth > 600 ? " : " + Email : ""} )
                </a>{" "}
              </div>
              <div
                className="btn-group btn-block"
                role="group"
                aria-label="..."
              >
                <a
                  href={"tel:" + Cellphone}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-primary btn-sm"
                >
                  <i className="fas fa-mobile-alt"></i>{" "}
                  {deviceWidth > 600 ? (
                    <span style={{ fontSize: "1.2em" }}>{Cellphone}</span>
                  ) : (
                    ""
                  )}
                </a>
                <a
                  href={"tel:" + Cellphone}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-primary btn-sm"
                >
                  <i className="fas fa-phone-square-alt"></i>{" "}
                  {deviceWidth > 600 ? (
                    <span style={{ fontSize: "1.2em" }}>{Telephone}</span>
                  ) : (
                    ""
                  )}
                </a>
              </div>
            </>
          );
        },
      },
      {
        title: () => {
          return this.state.deviceWidth > 600 ? "賃居狀態" : "狀態";
        },
        dataIndex: "",
        width: 40,
        responsive: ["md", "lg"],
        render: (item) => {
          const { deviceWidth } = this.state;
          const { LiveType, SATOTAL } = item;
          return (
            <>
              <div className="text-center">
                <Badge count={SATOTAL}>
                  <Tag
                    color={this.style_switch_color_tag("LiveType", LiveType)}
                  >
                    <i className="fas fa-home">
                      {" "}
                      {deviceWidth > 600 ? this.switch_live_tag(LiveType) : ""}
                    </i>
                  </Tag>
                </Badge>
              </div>
            </>
          );
        },
      },
      {
        title: "賃居資訊",
        dataIndex: "",
        width: 100,
        render: (item) => {
          const { deviceWidth } = this.state;
          const { LiveAddress, HouseOwnerName, HouseOwnerPhone } = item;
          return (
            <>
              <div className="text-center">
                <div>
                  <a
                    href={"tel:" + HouseOwnerPhone}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-dark btn-sm btn-block"
                  >
                    {" "}
                    <span style={{ fontSize: "1.3em" }}>
                      {HouseOwnerName}
                    </span>{" "}
                    ( <i className="fas fa-phone-volume"></i>{" "}
                    {deviceWidth > 600 ? HouseOwnerPhone : ""} )
                  </a>
                </div>
                <div>
                  <a
                    href={"http://maps.google.com/?q=" + LiveAddress}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-danger btn-sm btn-block"
                  >
                    <i className="fas fa-map-marker-alt"></i>{" "}
                    {deviceWidth > 600 ? LiveAddress : "位置"}
                  </a>
                </div>
              </div>
            </>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 70,
        render: (item) => {
          const { deviceWidth } = this.state;
          const { SATOTAL, TutorCheckDateTime, SchoolStatus, HasCourse } = item;
          return (
            <>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn btn-outline-secondary btn-sm"
                  style={{ color: SATOTAL > 0 ? "Red" : "Green" }}
                  onClick={() => this.handle_show_ui_response("student", item)}
                >
                  <i className="far fa-address-card"></i>{" "}
                  {deviceWidth > 600 ? (
                    <span style={{ marginLeft: "2px" }}>學生回報</span>
                  ) : (
                    ""
                  )}
                </button>
                {!SATOTAL > 0 &&
                formateDate(TutorCheckDateTime) === "1999-1-1 00:00:00" ? (
                  <button
                    type="button"
                    className="btn btn btn-danger btn-sm"
                    onClick={() => this.handle_show_ui_response("tutor", item)}
                  >
                    <i className="fas fa-search-location"></i>{" "}
                    {deviceWidth > 600 ? (
                      <span style={{ marginLeft: "10px" }}>待 訪 視</span>
                    ) : (
                      ""
                    )}
                  </button>
                ) : (
                  ""
                )}
                {formateDate(TutorCheckDateTime) !== "1999-1-1 00:00:00" ? (
                  <button
                    type="button"
                    class="btn btn btn-success btn-sm"
                    onClick={() => this.handle_show_ui_response("tutor", item)}
                  >
                    <i className="fas fa-tasks"></i>
                    {deviceWidth > 600 ? (
                      <span style={{ marginLeft: "10px" }}>已 訪 視</span>
                    ) : (
                      ""
                    )}
                  </button>
                ) : (
                  ""
                )}
                {SchoolStatus === "延修生" ? (
                  <>
                    <Tag color={"red"}>延</Tag>
                    {HasCourse === "IN" ? <Tag color={"gold"}>修</Tag> : ""}
                  </>
                ) : (
                  ""
                )}
              </div>
            </>
          );
        },
      },
    ];
  };

  switch_live_tag(param) {
    switch (param) {
      case "NONE":
        return "未填";
      case "MYHOUSE":
        return "自宅";
      case "DORM":
        return "宿舍";
      case "STAY":
        return "親友";
      case "CONTRACT":
        return "租屋";
      case "INTERN":
        return "實習";
      default:
        return "";
    }
  }

  style_switch_color_tag(column, param) {
    if (column === "LiveType") {
      switch (param) {
        case "NONE":
          return "red";
        case "MYHOUSE":
        case "DORM":
          return "green";
        case "STAY":
          return "purple";
        case "CONTRACT":
          return "orange";
        case "INTERN":
          return "blue";
        default:
          return "default";
      }
    }
    if (column === "ConfirmStatus") {
      switch (param) {
        case "NO":
          return "red";
        case "YES":
          return "green";
        default:
          return "default";
      }
    }
  }

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      console.log(status);
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  };

  handle_show_ui_response = (modal, item) => {
    // console.log(yearSurvey)
    if (modal === "student") {
      this.setState({ isShowStudentSurveyModal: true, item: item });
    } else if (modal === "tutor") {
      if (item.AppendixLiveCases) {
        const images = item.AppendixLiveCases.reduce((item_pre, item) => {
          if (item.FileCreator === "TUTOR") {
            item_pre.push(item);
          }
          return item_pre;
        }, []);
        item.AppendixLiveCases = images;
        this.setState({ isShowConfirmTutorModal: true, item });
      } else {
        this.setState({ isShowConfirmTutorModal: true, item });
      }
    }
    //console.log(this.responseYearSurveyCode)
  };

  handle_check_changed = () => {
    const tag = this.state.onlyShowNeedConfirmTag;
    const onlyShowNeedConfirmTag = tag === "NO" ? "YES" : "NO";
    this.setState({ onlyShowNeedConfirmTag }, () => {
      this.setState({ items: [] });
      this.api_page_items(this.current);
    });
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      pagination,
      isShowStudentSurveyModal,
      isShowConfirmTutorModal,
      item,
      deviceWidth,
      searchField,
      searchValue,
      onlyShowNeedConfirmTag,
    } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="ClassroomTwName">班級</Select.Option>
          <Select.Option value="TwName">學生姓名</Select.Option>
          <Select.Option value="StudentId">學生學號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search"></i>
          <span style={{ marginLeft: "4px" }}>
            {" "}
            {deviceWidth > 600 ? "查詢" : ""}
          </span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        {deviceWidth > 600 ? (
          <>
            <Button type="primary" onClick={() => this.handle_data_download()}>
              <i className="fas fa-cloud-download-alt element-hidden"></i>
              <span style={{ marginLeft: "4px" }}> 下載</span>
            </Button>
          </>
        ) : (
          ""
        )}
        <div>
          <Switch
            checkedChildren="僅顯示尚未訪視租屋地點"
            unCheckedChildren="顯示全部租屋地點"
            defaultChecked={onlyShowNeedConfirmTag === "NO" ? false : true}
            onClick={this.handle_check_changed}
          />
        </div>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_items,  // 有用過濾功能(filter)要註銷pagination.onChange
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          title="學生填報內容"
          visible={isShowStudentSurveyModal}
          cancelButtonProps={{ style: { display: "none" } }}
          width={1000}
          closable={false}
          onOk={() => {
            this.setState({ isShowStudentSurveyModal: false });
          }}
          okText="關閉"
        >
          <SurveyStudentModal student={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          title="現地訪視回報"
          visible={isShowConfirmTutorModal}
          cancelButtonProps={{ style: { display: "none" } }}
          width={1000}
          closable={false}
          onOk={() => {
            this.setState({ isShowConfirmTutorModal: false });
            this.api_page_items(this.current);
          }}
          okText="關閉"
        >
          <ConfirmTutorModal student={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(NeedConfirmTutor);
